import { rgba } from 'polished';
import { px2rem } from '../../helpers/rem.mjs';

function generateShadowSet(colorSet) {
  return {
    whiteElevated: "0 ".concat(px2rem(2), " ").concat(px2rem(8), " 0 ").concat(rgba(colorSet.grey800 || "#FFF", 0.2)),
    whiteElevated2: "0 ".concat(px2rem(2), " ").concat(px2rem(6), " ").concat(px2rem(1), " ").concat(colorSet.grey50),
    whiteElevated3: "0 ".concat(px2rem(4), " ").concat(px2rem(16), " 0 ").concat(rgba(colorSet.grey800 || "#FFF", 0.2))
  };
}

export { generateShadowSet as default };
